import React, { Suspense, useState } from 'react'
import { connect } from 'react-redux'
import { ContentHeader } from '../../../../components/Header/ContentHeader'
import { RootState } from '../../../../store/rootState'
import { IProject } from '../../types/project'
import { Dimmer, Loader } from 'semantic-ui-react'
import {  useHistory } from 'react-router'
import * as ProjectActions from '../../actions/projectActions'
import * as MainActions from '../../../main/actions/sidebarActions'
const ConfirmDeleteModal = React.lazy(() => import('../../../../components/Modal/ConfirmDeleteModal'))


interface StateProps {
  project: IProject
  formOpen: boolean
  formDirty: boolean
}

interface DispatchProps {
  setFormOpen: (open: boolean) => void
  setFormDirty: (dirty: boolean) => void
}

type Props = StateProps & DispatchProps

const ProjectSettingsHeader = (props: Props) => {
  const { project, formOpen, formDirty, setFormOpen, setFormDirty } = props
  const [renderCloseModal, setRenderCloseModal] = useState(false)

  const history = useHistory()

  const handleGoBack = () => {
    history.replace('/projects')
  }

  const handleConfirmBack = () => {
    if (formOpen && formDirty) {
      setRenderCloseModal(true)
    } else {
      handleGoBack()
    }
  }

  const confirmClose = (action: 'cancel' | 'delete') => {
    if (action === 'delete') {
      setFormOpen(false)
      setFormDirty(false)
      handleGoBack()
    }
    setRenderCloseModal(false)
  }


  return (
    <div>
      <ContentHeader
        title={project.name}
        subtitle={project.customer?.name ?? project.category}
        color='#08D6A1'
        backLocation='/projects'
        backTitle='Settings'
        onBackClick={handleConfirmBack}
      />

      <Suspense fallback={<Dimmer active inverted><Loader size='big' /></Dimmer>}>
        <ConfirmDeleteModal open={renderCloseModal} closeModal={true} userInput={confirmClose} />
      </Suspense>
    </div>
  )
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    project: state.projectsState.project,
    formOpen: state.mainState.formOpen,
    formDirty: state.mainState.formDirty
  }
}

const mapDispatchToProps = (
  dispatch: ProjectActions.ProjectThunkDispatchType & MainActions.MainThunkDispatchType
): DispatchProps => {
  return {
    setFormOpen: open => dispatch(MainActions.setFormOpen(open)),
    setFormDirty: dirty => dispatch(MainActions.setFormDrity(dirty))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectSettingsHeader)
